import { useState, useEffect } from "react";
import { SwalAlertClass } from "core/swalClass";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import WasteSelectorTypes from "components/waste-icons/WasteSelectorTypes";
import axiApi from "ApiCaller";

ChartJS.register(ArcElement, Tooltip, Legend);

const labels = [
  "0-10%",
  "10-20%",
  "20-30%",
  "30-40%",
  "40-50%",
  "50-60%",
  "60-70%",
  "70-80%",
  "80-90%",
  "90-100%",
];
const ContainersFilling = () => {
  const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
  const [datasets, setDatasets] = useState([]);
  const DataSet = function (type, data) {
    return {
      label: WasteSelectorTypes.getName(type),
      data: data,
      backgroundColor: WasteSelectorTypes.getBackgroundColor(type),
      borderColor: WasteSelectorTypes.getBorderColor(type),
      borderWidth: 1,
    };
  };

  const DataBar = {
    labels: labels,
    datasets: datasets,
  };

  const OptionsBar = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "rect",
          font: {
            size: 10,
          },
        },
      },
      title: {
        display: true,
        text: "Llenado de contenedores según fracción",
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            return `Cantidad: ${tooltipItem.raw}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  useEffect(() => {
    axiApi
      .get("/api/home/filling/")
      .then((resp) => {
        if (resp.data.status) {
          let values = [];
          Object.entries(resp.data.containers).forEach(([key, data]) => {
            values.push(new DataSet(key, data));
          });
          setDatasets(values);
        } else {
          Alert.error(
            "Error in ContainerFilling.API",
            "Se ha encontrado un error en la carga del mapa."
          );
        }
      })
      .catch((error) => {
        console.log(error);
        Alert.error(
          "Error in ContainerFilling.API",
          "Se ha encontrado un error en la carga del mapa."
        );
      });
  }, []);

  return (
    <div className="border h-100">
      <Bar data={DataBar} options={OptionsBar} />
    </div>
  );
};

export default ContainersFilling;
